export const formatRemainingTime = (
  ms: number,
  timeStaticTexts: { hours: string; minutes: string; seconds: string }
) => {
  const hours = Math.floor(ms / 1000 / 60 / 60);
  const minutes = Math.floor((ms / 1000 / 60) % 60);
  const seconds = Math.floor((ms / 1000) % 60);
  if (hours > 0) {
    return `${hours}${timeStaticTexts.hours} ${minutes}${timeStaticTexts.minutes} ${seconds}${timeStaticTexts.seconds}`;
  }
  if (minutes > 0) {
    return `${minutes}${timeStaticTexts.minutes} ${seconds}${timeStaticTexts.seconds}`;
  }
  return `${seconds}${timeStaticTexts.seconds}`;
};

export const getRemainingTimeMessage = (
  releaseTime: string | undefined,
  releaseMessage: string | undefined,
  timeStaticTexts: { hours: string; minutes: string; seconds: string }
) => {
  if (!releaseTime || !releaseMessage) {
    return;
  }

  const releaseDate = new Date(releaseTime);
  const remainingTime = releaseDate.getTime() - Date.now();
  const adjustedRemainingTime = remainingTime > 0 ? remainingTime : 0;

  const highlightedMessage = releaseMessage.replace(
    '$0',
    formatRemainingTime(adjustedRemainingTime, timeStaticTexts)
  );

  return highlightedMessage;
};
